import { LoanApplicationService } from '../loan-application.service';
import { WebsiteStatesService } from '../../../website-states.service';
var PageOneComponent = /** @class */ (function () {
    function PageOneComponent(loan, website) {
        this.loan = loan;
        this.website = website;
    }
    PageOneComponent.prototype.backward = function () {
        this.loan.backward();
    };
    PageOneComponent.prototype.forward = function () {
        if (this.isValid) {
            this.loan.forward();
        }
        else {
            this.markAllDirty(this.loan.form.get('employment_info'));
            this.markAllDirty(this.loan.form.get('personal_info'));
            this.markAllDirty(this.loan.form.get('branch'));
        }
        this.website.scrollToTop();
    };
    Object.defineProperty(PageOneComponent.prototype, "isValid", {
        get: function () {
            return this.loan.form.get('employment_info').valid &&
                this.loan.form.get('personal_info').valid &&
                this.loan.form.get('branch').valid;
        },
        enumerable: true,
        configurable: true
    });
    PageOneComponent.prototype.markAllDirty = function (control) {
        // Credit: https://github.com/angular/angular/issues/11774#issuecomment-264706699
        if (control.hasOwnProperty('controls')) {
            control.markAsDirty();
            var ctrl = control;
            for (var _i = 0, _a = Object.keys(ctrl.controls); _i < _a.length; _i++) {
                var inner = _a[_i];
                this.markAllDirty(ctrl.controls[inner]);
            }
        }
        else {
            (control).markAsDirty();
            (control).markAsTouched();
        }
    };
    return PageOneComponent;
}());
export { PageOneComponent };
